import Header from "@/components/hotel/Header";
import SubpageHero from "@/components/hotel/SubpageHero";
import FamilyRoom from "@/components/hotel/FamilyRoom";
import Footer from "@/components/hotel/Footer";
import SEO, { BASE_URL } from "@/components/SEO";
import { useLanguage } from "@/i18n/LanguageContext";

const FamilyRoomPage = () => {
  const { t } = useLanguage();
  return (
    <main id="main-content" className="min-h-screen bg-background">
      <SEO
        title="Familienzimmer"
        description="Geräumiges Familienzimmer im ESOS Hotel Quelle Bad Ragaz – ideal für Familien mit Kindern, mit allem Komfort ausgestattet."
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Zimmer", path: "/rooms" },
          { name: "Familienzimmer", path: "/rooms/family" },
        ]}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "HotelRoom",
          name: "Familienzimmer",
          description: "Geräumiges Familienzimmer mit Doppelbett, Einzelbett und Sofabett – ideal für Familien.",
          url: `${BASE_URL}/rooms/family`,
          bed: [
            { "@type": "BedDetails", typeOfBed: "Doppelbett", numberOfBeds: 1 },
            { "@type": "BedDetails", typeOfBed: "Einzelbett", numberOfBeds: 1 },
            { "@type": "BedDetails", typeOfBed: "Sofabett", numberOfBeds: 1 },
          ],
          occupancy: { "@type": "QuantitativeValue", minValue: 1, maxValue: 4 },
          amenityFeature: [
            { "@type": "LocationFeatureSpecification", name: "WLAN", value: true },
            { "@type": "LocationFeatureSpecification", name: "TV", value: true },
            { "@type": "LocationFeatureSpecification", name: "Eigenes Bad", value: true },
            { "@type": "LocationFeatureSpecification", name: "Parkplatz", value: true },
          ],
        }}
      />
      <Header />
      <SubpageHero title={t.subpageHeroes.familyRoom.title} subtitle={t.subpageHeroes.familyRoom.subtitle} />
      <FamilyRoom />
      <Footer />
    </main>
  );
};

export default FamilyRoomPage;
